import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, uploadFile, removeFile } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "cateringeventtype";
var moduleName = "Event Type";
var modulePath = "/clientpanel/catering-event";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || '',
      pageloading: false,
      clientdata: {
        cateringEventTypeName: "",
        cateringEventTypeStatus: "",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
    };
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${ecommerceapiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          const cateringEventTypeStatus = result.cateringEventTypeStatus === "A" ? "Active" : "Inactive";
          const status =
            result.cateringEventTypeStatus !== "" && result.cateringEventTypeStatus !== null
              ? {
                  label: cateringEventTypeStatus,
                  value: result.cateringEventTypeStatus,
                }
              : "";

          var clientupdatedata = {
            cateringEventTypeName: result.cateringEventTypeName,
            cateringEventTypeStatus: status,
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid Tag", "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    var postObject = {
      cateringEventTypeName: postData.cateringEventTypeName,
      cateringEventTypeStatus: postData?.cateringEventTypeStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method, "ecom");
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catering-event"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method, urlType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method, urlType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));
function validationConfig(props) {
  const { cateringEventTypeName, cateringEventTypeStatus } = props.fields;

  return {
    fields: ["cateringEventTypeName", "cateringEventTypeStatus"],

    validations: {
      cateringEventTypeName: [[isEmpty, cateringEventTypeName]],
      cateringEventTypeStatus: [[isSingleSelect, cateringEventTypeStatus]],
    },
  };
}

class PostForm extends Component {
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgName,
      errMsgStatus = "";
    if ($validation.cateringEventTypeName.error.reason !== undefined) {
      errMsgName = $validation.cateringEventTypeName.show && <span className="error">{$validation.cateringEventTypeName.error.reason}</span>;
    }
    if ($validation.cateringEventTypeStatus.error.reason !== undefined) {
      errMsgStatus = $validation.cateringEventTypeStatus.show && <span className="error">{$validation.cateringEventTypeStatus.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 mt-2">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={errMsgName !== "" && errMsgName !== false && errMsgName !== undefined ? "form-control is-invalid" : "form-control"}
                name="cateringEventTypeName"
                value={fields.cateringEventTypeName}
                {...$field("cateringEventTypeName", (e) => onChange("cateringEventTypeName", e.target.value))}
              />
              <label htmlFor="cateringEventTypeName">
                Event Type Name <span className="error">*</span>
              </label>
              {errMsgName}
            </div>
          </div>
          <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.cateringEventTypeStatus}
                onChange={this.handleSelectChange.bind(this, "cateringEventTypeStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
